<template>
  <div>
    <b-button-toolbar class="my-3">
      <b-button
        v-for="(j,index) in actie.jaren"
        :key="index"
        :variant="getButtonVariant(index)"
        class="mr-2"
        @click="onClick(index)"
      >
        <i 
          v-if="j.uitgevoerd" 
          class="fa fa-check"
        />
        {{ j.jaar }}
        <b-badge
          :class="getConditieClass(getConditie(j.jaar-getJaarN(index,actie),actie.levensduur))"
          pill
        >
          {{ getConditie(j.jaar-getJaarN(index,actie),actie.levensduur) }}
        </b-badge>
      </b-button>

      <b-button
        v-if="actie.jaren.length > 0"
        :pressed.sync="deleteModus"
        :variant="deleteModus ? 'danger' : 'outline-danger'"
      >
        <i :class="['fa', deleteModus ? 'fa-mouse-pointer' : 'fa-trash', 'mr-1']" />
        {{ deleteModus ? 'klik om te verwijderen' : 'verwijderen' }}
      </b-button>
    </b-button-toolbar>

    <b-col lg="6">
      <b-card 
        v-if="selectedItem" 
        bg-variant="primary" 
        no-body
      >
        <b-card-header>
          <b-button
            v-if="selectedItem.jaar != (getJaarN(itemIndex,actie)+actie.cyclus)"
            :class="[getConditieClass(getConditie(actie.cyclus,actie.levensduur)), 'pull-right']"
            @click="selectedItem.jaar= (getJaarN(itemIndex,actie)+actie.cyclus)"
          >
            {{ getJaarN(itemIndex,actie)+actie.cyclus }}
          </b-button>
          <h5>
            Conditie
            <b-badge
              :class="getConditieClass(getConditie(selectedItem.jaar-getJaarN(itemIndex,actie),actie.levensduur))"
            >
              {{ getConditie(selectedItem.jaar-getJaarN(itemIndex,actie),actie.levensduur) }}
            </b-badge>
            in {{ selectedItem.jaar }}
          </h5>
        </b-card-header>
        <b-card-body>
          <b-form-input
            v-model.number="selectedItem.jaar"
            size="lg"
            type="number"
            placeholder="jaartal"
          />
        </b-card-body>
        <b-card-footer footer-bg-variant="info">
          <b-input-group class="my-1">
            <b-input-group-text>
              <b-check v-model="selectedItem.uitgevoerd">
                uitgevoerd
              </b-check>
            </b-input-group-text>
          </b-input-group>
        </b-card-footer>
      </b-card>
    </b-col>
    <b-button-toolbar class="my-3">
      <b-input-group-text>
        En dan na {{ getBeginCyclus(actie) }}
        <i class="fa fa-refresh mx-1" />
        {{ actie.cyclus }} jaar:
      </b-input-group-text>

      <b-dropdown
        class="mx-3"
        split
        @click="actie.jaren.push({ jaar : getBeginCyclus(actie)+actie.cyclus , stuck:false})"
      >
        <template slot="button-content">
          <i class="fa fa-plus" />
          {{ getBeginCyclus(actie)+actie.cyclus }}
          <b-badge
            :class="getConditieClass(getConditie(actie.cyclus,actie.levensduur))"
            pill
          >
            {{ getConditie(actie.cyclus,actie.levensduur) }}
          </b-badge>
        </template>
        <b-dropdown-item
          v-for="(i) in getJaren(getBeginCyclus(actie),actie.cyclus)"
          :key="i"
          pill
          class="mr-2 btn-sm"
          @click="actie.jaren.push({ jaar : i , stuck:false})"
        >
          <i class="fa fa-plus" />
          {{ i }}
          <b-badge
            :class="getConditieClass(getConditie(i - getBeginCyclus(actie),actie.levensduur))"
            pill
          >
            {{ getConditie(i - getBeginCyclus(actie),actie.levensduur) }}
          </b-badge>
        </b-dropdown-item>
      </b-dropdown>
    </b-button-toolbar>
  </div>
</template>

<script>
import { conditieMixin } from "@/mixins/conditieMixin";
import { actieMixin } from "@/mixins/actieMixin";

export default {
  name: "CyclusDetails",
  mixins: [conditieMixin, actieMixin],
  props: {
    jaar: { type: Number, default: new Date().getFullYear() },
    actie: {
      type: Object
    }
  },
  data() {
    return {
      deleteModus: false,

      itemIndex: null
    };
  },
  computed: {
    selectedItem: function() {
      return this.actie.jaren[this.itemIndex] || null;
    }
  },
  methods: {
    getButtonVariant(index) {
      if (this.deleteModus) return "outline-danger";
      if (this.itemIndex == index) return "primary";
      //deleteModus ? 'danger' : 'secondary'
      return "secondary";
    },
    onClick(index) {
      if (this.deleteModus) {
        this.actie.jaren.splice(index, 1);
      } else {
        this.itemIndex = index;
      }
    }
  }
};
</script>